<!--
Author: ia
Create Time: 2019-07-23 11:15:08
Description:
-->
<template>
  <el-popover
    class="com-table-select"
    popper-class="custom-popover"
    placement="bottom-start"
    :title="title"
    :width="widthValue"
    trigger="click"
    content
    v-model="visible"
    :disabled="disabled"
  >
    <el-input
      placeholder
      v-bind:value="text"
      :readonly="false"
      slot="reference"
      @click="openPopover"
      :disabled="disabled"
      :clearable="clearable"
      @clear="clearSelection"

      :title="text"
    ></el-input>
    <slot name="aboveFilter"></slot>
    <slot name="filter">
      <el-input placeholder="搜索" v-model="filter" :clearable="true" @keyup.native="handleFilterChange"></el-input>
    </slot>
    <slot name="belowFilter"></slot>
    <slot name="aboveTable"></slot>
    <el-scrollbar>
      <simplfyTable
        :colConfigs="colConfigs"
        :data="data"
        @row-click="handleRowClick"
        :row-style="genRowStyle"
        :stripe="false"

        size="mini"
      />
    </el-scrollbar>
    <slot name="pager">
      <el-pagination
        @current-change="handleCurrentPageChange"
        layout="prev, pager, next"
        :total="pageInfo.totalCount"
        :page-size="pageInfo.pageSize"
      ></el-pagination>
    </slot>
    <slot name="belowTable"></slot>
  </el-popover>
</template>

<script>
import simplfyTable from "../grid/simplfyTable.vue";

export default {
  name: "tableSelect",
  components: {
    simplfyTable
  },
  props: {
    title: {
      type: String,
      default: () => "列表选择"
    },
    disabled: {
      type: Boolean,
      default: () => false
    },
    clearable: {
      type: Boolean,
      default: () => false
    },

    idProp: {
      type: String,
      default: () => "id"
    },
    codeProp: {
      type: String,
      default: () => "code"
    },
    codeLabel: {
      type: String,
      default: () => "编码"
    },
    nameProp: {
      type: String,
      default: () => "name"
    },
    nameLabel: {
      type: String,
      default: () => "名称"
    },
    additionFields: {
      type: Array, // Array<{prop: string, label: string}>
      default: () => []
    },
    joinSeperator: {
      type: String,
      default: () => ","
    },
    formatter: {
      type: Function,
      default: ({ selection, idProp, codeProp, nameProp, joinSeperator }) => {
        return selection
          .map(item => {
            return (item && item[idProp]) || "";
          })
          .join(joinSeperator);
      }
    },
    formatterText: {
      type: Function,
      default: ({ selection, idProp, codeProp, nameProp, joinSeperator }) => {
        return selection
          .map(item => {
            return (
              (item && item[nameProp]) || ""
            );
          })
          .join(joinSeperator);
      }
    },

    // table
    data: {
      type: Array,
      default: () => []
    },
    // 是否多选
    multiple: {
      type: Boolean,
      default: () => false
    },

    value: {
      type: String,
      default: () => ""
    },

    width: {
      type: [Number, String],
      default: () => 0
    },

    pageInfo: {
      type: Object,
      default: () => ({
        currentPage: 1,
        pageSize: 10,
        totalCount: 0
      })
    }
  },
  data() {
    return {
      visible: false,

      filter: "",

      widthValue: 0,
      selection: []
    };
  },
  computed: {
    colConfigs() {
      const arr = [
        {
          prop: this.codeProp,
          label: this.codeLabel
        },
        {
          prop: this.nameProp,
          label: this.nameLabel
        },
        ...this.additionFields
      ];

      /* 
      if (this.multiple) {
        arr.unshift({
          type: "selection"
        });
      }
       */

      return arr;
    },
    text() {
      return this.formatterText({
        selection: this.selection,
        idProp: this.idProp,
        codeProp: this.codeProp,
        nameProp: this.nameProp,
        joinSeperator: this.joinSeperator
      });
    }
  },
  watch: {
    value(val) {
      if (!val) {
        this.clearSelection();
      }
    }
  },
  methods: {
    openPopover() {
      this.visible = true;
    },
    closePopover() {
      this.visible = false;
    },
    handleSelectionChange(selection) {
      this.emitInput();
    },
    handleRowClick(row) {
      if (this.multiple) {
        let idx = this.selection.findIndex(
          item => item && item[this.idProp] === row[this.idProp]
        );
        if (idx > -1) {
          this.selection.splice(idx, 1);
        } else {
          this.selection.push(row);
        }
        this.emitInput();
      } else {
        // this.selection = row ? [row] : [];
        this.selection = [row];
        this.emitInput();
        this.visible = false;
      }
    },
    genRowStyle({ row, rowIndex }) {
      const selected =
        this.selection.length > 0 &&
        this.selection.some(
          item => item && item[this.idProp] === row[this.idProp]
        );
      return {
        backgroundColor: selected ? "rgb(236, 255, 255)" : "white",
        cursor: "pointer"
      };
    },
    clearSelection() {
      this.selection = [];
      this.emitInput();
    },
    setSelection(selection) {
      if (this.multiple) {
        this.selection = [...selection];
      } else {
        this.selection =
          selection.length > 0 && selection[0] ? selection.slice(0, 1) : [];
      }
    },
    emitInput() {
      this.$emit(
        "input",
        this.formatter({
          selection: this.selection,
          idProp: this.idProp,
          codeProp: this.codeProp,
          nameProp: this.nameProp,
          joinSeperator: this.joinSeperator
        })
      );
    },
    handleCurrentPageChange(currentPage) {
      this.$emit('current-page-change', currentPage);
    },
    handleFilterChange() {
      this.$emit('filter-change', this.filter);
    }
  },
  mounted() {
    this.$nextTick(function() {
      if (this.width) {
        this.widthValue = this.width;
        return;
      }
      this.widthValue = this.$el.getBoundingClientRect().width;
    });
  }
};
</script>

<style scoped lang="less">
// .com-table-select {}
/deep/ .el-input__inner{
  margin-bottom: 10px !important;
}
/deep/ .el-scrollbar{
  margin-top: 10px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/tableSelect/tableSelect.vue